import { domReady } from 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Helper';
import ScrollEffect from './ScrollEffect';
import initSwiper from './InitSwiper';

function init() {
    initSwiper();
    ScrollEffect({
        selector: '.swiper-type--image',
        blur: false,
        headline: true,
    });
}

try {
    _gg.onReady.Swiper = init;

    // Make sure it worked
    setTimeout(function () {
        if (document.querySelector('.swiper-container') && !document.querySelector('.swiper--initialized-true')) {
            init();
        }
    }, 10);
} catch (error) {
    domReady(init);
}
